import { render } from "./ShelfSection.vue?vue&type=template&id=0256ec5b&scoped=true"
import script from "./ShelfSection.vue?vue&type=script&lang=js"
export * from "./ShelfSection.vue?vue&type=script&lang=js"

import "./ShelfSection.vue?vue&type=style&index=0&id=0256ec5b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0256ec5b"]])

export default __exports__